// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionAdministration_container__Z9T8o","button-container":"SubscriptionAdministration_button-container__NBHGr"};